import React from 'react';
import { FontSizeType } from '../styles/functions';
import { TypographyFontWeightModel } from '../Typography/tools/Typography.model';
import { NumberValue } from '../NumberValue/NumberValue';
import Decimal from 'decimal.js';

export interface CurrencyProps {
  value?: Decimal | number;
  income?: boolean;
  showSignWithoutColours?: boolean;
  toFixed?: number;
  suffix?: string;
  classNameSkeleton?: string;
  autoTestId?: string;
  valueSize?: FontSizeType,
  codeSize?: FontSizeType,
  valueClassName?: string,
  codeClassName?: string,
  fontWeight?: TypographyFontWeightModel,
  valueFontWeight?: TypographyFontWeightModel,
  codeFontWeight?: TypographyFontWeightModel,
}

const Currency: React.FC<CurrencyProps> = ({
  value,
  income,
  showSignWithoutColours = false,
  toFixed = 2,
  suffix = 'PLN',
  classNameSkeleton,
  autoTestId,
  valueSize='base',
  codeSize='base',
  valueClassName,
  codeClassName,
  fontWeight,
  valueFontWeight = 'normal',
  codeFontWeight = 'normal',
}) => {
  const effectiveFontWeight = fontWeight ?? (income ? 'bold' : 'normal');

  return <NumberValue
            autoTestId={autoTestId}
            value={value}
            decimalScale={toFixed}
            income={income}
            showSignWithoutColours={showSignWithoutColours}
            suffix={suffix}
            classNameSkeleton={classNameSkeleton}
            valueSize={valueSize}
            codeSize={codeSize}
            valueClassName={valueClassName}
            codeClassName={codeClassName}
            fontWeight={effectiveFontWeight}
            valueFontWeight={valueFontWeight}
            codeFontWeight={codeFontWeight}
          />;
};

export { Currency };
